import React, { Component } from 'react';
import LoadingComponent from '../../commonComponents/LoadingComponent';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css' // If using WebPack and style-loader.
import CallAPI from '../../commonComponents/AxiosHelper';
import getParametersFromString from '../../commonComponents/Helper';
class StepOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: this.props.data,
            tags: [],
            triggle:false,
        };
        this.handleButton = this.handleButton.bind(this); 
        this.getData = this.getData.bind(this);
    }
    handleTabChange(e) {
        // var tabSelected = jQuery(e.target).attr('href');
        let tabSelected = (e.target.innerText).toLowerCase();
        var newURL = window.location.href;
        if (tabSelected == 'property' || tabSelected == 'dimension') {
            newURL = window.location.origin + window.location.pathname + '?type=property';
        } else if (tabSelected == 'metric') {
            newURL = window.location.origin + window.location.pathname + '?type=metric';
        }
        // } else if (tabSelected == '#metricsection') {
        //     newURL = window.location.origin + window.location.pathname + '?type=format';
        // } else if (tabSelected == '#synonyms') {
        //     newURL = window.location.origin + window.location.pathname + '?type=label';
        // }
        history.pushState({}, null, newURL);
        this.setState({});
    }
    componentWillReceiveProps(nextProps) {
        this.updateStates(nextProps);
    }
    componentDidMount() {
        this.updateStates(this.props);
    }
    updateStates(finalProps) {
        var tags = finalProps.data.map(function (innerData, i) {
            if (innerData['synonyms'])
                return innerData['synonyms'].split(',');
            else return [];
        })
        this.setState({ columns: finalProps.data, tags: tags })
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }
    getData(e) {
        e.preventDefault();
        var that = this;
        var allData = [];
        let checkValidity = true;
        this.state.columns.map(function (innerData, i) {
            if (checkValidity && (innerData.property === e.target.name)) {
                var temp = {};
                temp.name = document.getElementById('name' + i).value;
                temp.label = document.getElementById('label' + i).value;
                temp.synonyms = that.state.tags[i].toString();

                if(innerData.property === 'property') {
                    checkValidity = checkSpecialChars(temp.label, 'propertyLabel') ? false : true
                } else if(innerData.property === 'metric') {
                    checkValidity = checkSpecialChars(temp.label, 'metricLabel') ? false : true
                }
                that.state.tags[i].map(function (innerElement) {
                    if(innerData.property === 'property') {
                        checkValidity = checkValidity ? (checkSpecialChars(innerElement) ? false : true) : false
                    } else if(innerData.property === 'metric') {
                        checkValidity = checkValidity ? (checkSpecialChars(innerElement, 'metricLabel') ? false : true) : false
                    }
                })
            }
            checkValidity && temp ? allData.push(temp) : null;
        })
        if (checkValidity === false) {
            let alertMessage = e.target.name == 'property'
                ? 'Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-), underscore(_) are allowed.)'
                : 'Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-), underscore(_), percent(%) are allowed.)'
            alert(alertMessage)
        } else {
            let siteId = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null;
            let toolId = this.props.datasetValue;
            // let toolId = localStorage.Dataset ? JSON.parse(localStorage.Dataset).value : null;
            if (confirm("Please Confirm to Update!")) {
                if (e.target.name == 'property') {
                    jQuery("#configSearchPropSave").attr('hidden', true);
                    jQuery("#propLoadingButton").removeAttr('hidden');
                } else {
                    jQuery("#configSearchKpiSave").attr('hidden', true);
                    jQuery("#kpiLoadingButton").removeAttr('hidden');
                }
                let url = '/app/getheaderdataforrefine?siteId=' + siteId + "&toolId=" + toolId + "&type=" + e.target.name;
                CallAPI('post', url, allData, null, 0, function (response) {
                    if(response?.status==false){
                        checkIfMaintenanceModeOn(response)
                    }
                    alert("Updated Successfully!");
                    // window.location.reload();
                    that.props.fetchSynonym();
                }, this.props.authData);
            }
            //return false;
        }
    }
    handleChange(index, tags) {
        var coreTags = this.state.tags;
        coreTags[index] = tags;
        this.setState({ tags: coreTags });
    }

    handleButton(e) {
        if (e.target.id == "editButton") {
            jQuery("#saveButton").removeAttr('hidden');
            jQuery("#cancelButton").removeAttr('hidden');
            jQuery("#editButton").attr('hidden', true);
        }
        else if (e.target.id == "cancelButton") {
            jQuery("#saveButton").attr('hidden', true);
            jQuery("#cancelButton").attr('hidden', true);
            jQuery("#editButton").removeAttr('hidden');
        }
    }
    
    render() {

        if (this.state.columns && this.state.tags.length > 1) {
            var tableRow = [];
            var columns = this.state.columns;
            var previousvalueheader = null;
            var that = this;
            columns.map(function (innerData, i) {
                var tempTableRow = (
                    <tr key={i}>
                        <td className='' style={{ minWidth: "200px", maxWidth: "300px", width: "250px", wordBreak: "break-word" }}><span className="tx-14">{innerData['value']}</span><input type="hidden" name={"name" + i} defaultValue={innerData['value']} id={'name' + i} /></td>
                        <td className='' style={{ minWidth: "200px", maxWidth: "300px", width: "200px", wordBreak: "break-word" }}><input
                            type='text'
                            className='form-control w-100'
                            // style={{ width: "140px" }}
                            placeholder='Label for column name'
                            name={'label' + i}
                            defaultValue={innerData['name']}
                            id={'label' + i} /></td> {/* tagProps = {{ classNameRemove: 'react-tagsinput-remove' ,  className: 'react-tagsinput-tag'}} */}
                        <td><TagsInput value={that.state.tags[i]} onChange={that.handleChange.bind(that, i)} name={"tags" + i} id={"tags" + i} onlyUnique={true} /></td>
                    </tr>
                )
                if (tableRow[innerData['property']])
                    tableRow[innerData['property']].push(tempTableRow);
                else {
                    tableRow[innerData['property']] = [];
                    tableRow[innerData['property']].push(tempTableRow);
                }
            })
            // tableRow['property'].push(
            //     <tr key={'100'}>
            //         <td>
            //             <button className='tableinputs btn-sm btn-primary' type="submit">Submit</button>
            //         </td>
            //         <td colSpan='2'></td>
            //     </tr>
            // );
            // tableRow['metric'].push(
            //     <tr key={'1001'}>
            //         <td>
            //             <button className='tableinputs btn-sm btn-primary' type="submit">Submit</button>
            //         </td>
            //         <td colSpan='2'></td>
            //     </tr>
            // );
            var activeTab = getParametersFromString('type', location.search);
            let propertyTab = "";
            let metricTab = "";
            if (activeTab == 'metric') {
                    metricTab ='active';
                    propertyTab='';
            } else if (activeTab == 'property') {
                    metricTab='',
                    propertyTab= 'active'
            }
            var loadingDataButton = (<button className='btn btn-sm btn-primary mg-y-5 mg-l-auto' id={activeTab == 'property' ? 'propLoadingButton' : 'kpiLoadingButton'} type="button" hidden='hidden' disabled>
                <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span>
                Please wait, Updating data...
            </button>)

            return (
                <div className="responsive-table col-md-12" style={{margin: '0px',padding: "0px"}}>
                    <div className="tabbable">
                        <div className="d-flex flex-row">  
                         
                            {/* <button id="editProperty" onClick={this.handleButton} className="btn btn-sm btn-primary mg-b-5 mg-r-15 mg-l-auto" type="button">Edit</button>
                            <button id="saveProperty" onClick={this.getData} className='btn btn-sm btn-primary mg-l-auto' type="submit" hidden>Save</button> */}
                            {/* <button id="submitKPI"  o onClick={this.submitHandle} className="btn btn-sm btn-primary mg-b-5 mg-r-15" type="button" hidden>Save</button> */}
                            {/* <button id="cancelProperty" onClick={this.handleButton} className="btn btn-sm btn-primary mg-l-10 mg-r-15" type="button" hidden>Cancel</button> */}
                        </div>
                        <ul className="nav nav-line" id="labels_tab">
                            <li className="nav-item">
                                <a className={`nav-link green-border tx-14 ${propertyTab}`} data-toggle="tab" href="javascript:void(0)" onClick={this.handleTabChange.bind(this)}>
                                {/* <i className="fa fa-outdent"></i> */}
                                {/* <span>Property</span> */}
                                <span>Dimension</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link green-border tx-14 ${metricTab}`} data-toggle="tab" href="javascript:void(0)" onClick={this.handleTabChange.bind(this)}>
                                {/* <i className="fas fa-cash-register"></i> */}
                                <span>Metric</span>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content" style={{ marginBottom: "-25px" }}>

                            <div className={"tab-pane" + propertyTab} id="propertyTab"  >
                                <form autoComplete='off' action="#" onSubmit={this.getData.bind(this)} name="property" id="property" >
                                    <div className="d-flex flex-row justify-content-end">  
{/* // onClick={this.getData} */}
                                    {/* <button id="editButton" name="property" onClick={this.handleButton} className="btn btn-sm btn-primary mg-y-5 mg-r-15 mg-l-auto" type="button">Edit</button> */}
                                        <button id="configSearchPropSave" name="property" className='btn btn-sm btn-primary mg-y-5 ' type="submit">Save</button>
                                        {/* <button id="cancelButton" name="property" onClick={this.handleButton} className="btn btn-sm btn-primary mg-l-10  mg-y-5 mg-r-15" type="button" hidden>Cancel</button> */}
                                        {loadingDataButton}
                                    </div>
                                    <table className="table table-bordered" style={{width: '100%'}}>
                                        <thead>
                                        <tr>
                                                <th>Column Name</th>
                                                <th >Label</th>
                                                <th>{"Synonyms"}
                                                    {/* <a href="#" data-placement="bottom" data-toggle="tooltip" title='Add comma seperated values'><i className='fa fa-question-circle'></i></a> */}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableRow["property"]}
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                            <div className={"tab-pane" + metricTab} id="metricTab" >
                                <form autoComplete='off' action="#" onSubmit={this.getData.bind(this)} name="metric" id="metric">
                                    <div className="d-flex flex-row">
                                        {/* // onClick={this.getData} */}
                                        {/* <button id="editButton" name="metric" onClick={this.handleButton} className="btn btn-sm btn-primary mg-y-5 mg-r-15 mg-l-auto" type="button">Edit</button> */}
                                        <button id="configSearchKpiSave" name="metric" className='btn btn-sm btn-primary mg-y-5 mg-l-auto' type="submit">Save</button>
                                        {/* <button id="cancelButton" name="metric" onClick={this.handleButton} className="btn btn-sm btn-primary mg-l-10 mg-y-5 mg-r-15" type="button" hidden>Cancel</button> */}
                                        {loadingDataButton}
                                    </div>
                                    <table

                                        className="table table-bordered"
                                        style={{
                                            width: '100%',
                                        }}>
                                        <thead>
                                            <tr>
                                                <th>Column Name</th>
                                                <th style={{ overflow: "hidden" }}>Label</th>
                                                <th>{"Synonyms"}
                                                    {/* <a href="#" data-placement="bottom" data-toggle="tooltip" title='Add comma seperated values'><i className='fa fa-question-circle'></i></a> */}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableRow['metric']}
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (<LoadingComponent />);
        }
    }
}
export default StepOne;